import styled from "styled-components";

import { Palette } from "../../../core/styles/palette";
import { TableColumnWidth } from "../types/types";
import { tableStyle } from "./BaseTableStyle";

export const ActionTableStyle = styled.div`
    // export const ActionTableStyle = styled(Table)
    // Vanilla styles injection
    ${tableStyle};
    // // override header background color
    // :where(.css-dev-only-do-not-override-p7e5j5).ant-table-wrapper .ant-table-thead > tr > th {
    //     background-color: ${Palette.White};
    // }
    //
    // // override selected (checked) item. Important overrides ant primary color theme
    // .ant-table-row-selected > .ant-table-cell {
    //     background-color: ${Palette.DarkGreen} !important;
    //     color: ${Palette.White} !important;
    // }
    //
    // // override table cells
    // :where(.css-dev-only-do-not-override-p7e5j5).ant-table-wrapper .ant-table-tbody > tr > td {
    //     padding: 0 16px;
    // }
    //
    // .ant-table-cell {
    //     max-width: ${TableColumnWidth.LARGE};
    //     min-width: ${TableColumnWidth.SMALL};
    // }
    //
    // // important overrides styles on .ant-table-cell
    // .ant-table-cell.ant-table-selection-column {
    //     min-width: ${TableColumnWidth.EXTRA_SMALL} !important;
    // }

    // when an item in the table is RO it is disabled
    .aevi-read-only-row {
        color: ${Palette.DisabledColor} !important;
        background: ${Palette.DisabledBackground};
        cursor: not-allowed;
        pointer-events: none;

        // td now sets its own explicit cursor (see BaseTableStyle), so it no longer
        // inherits not-allowed from this row - reassert it here
        td {
            cursor: not-allowed;
        }

        // if a RO row contains a clickable cell, the styles are disabled
        .aevi-clickable-cell {
            border: none;
        }
    }

    // override pagination active item
    // .ant-pagination {
    //     margin: 20px 0;
    //     // arrows
    //     svg {
    //         color: ${Palette.FormText};
    //         scale: 170%;
    //     }
    //     .ant-pagination-disabled svg {
    //         color: ${Palette.DisabledColor};
    //     }
    //     .ant-pagination-prev {
    //         margin-inline-end: 0;
    //     }
    //     // all items
    //     .ant-pagination-item {
    //         margin: 0 10px;
    //     }
    //     a {
    //         font-family: RobotoMedium;
    //     }
    //     // active (green) element
    //     .ant-pagination-item-active {
    //         border-color: ${Palette.HeroGreen};
    //         border: none;
    //         a {
    //             color: ${Palette.HeroGreen};
    //         }
    //     }
    // }
`;

export const TableStyle = styled(ActionTableStyle).attrs(() => ({ className: "aevi-table" }))``;
